import { render, staticRenderFns } from "./InputContact.vue?vue&type=template&id=326258e1"
import script from "./InputContact.vue?vue&type=script&lang=ts"
export * from "./InputContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports